import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import "./styles/common.scss";
import "./styles/catalog.scss";
import "./styles/page-heroes.scss";
import App from "./App";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
);
